import { complete } from "./create"
import { getStudyAreas } from "./get-study-areas"

export const onboarding = {
  complete,
  getStudyAreas,
}
